<script>
    import { fade }       from 'svelte/transition'
    import { getContext } from 'svelte'
    import * as api       from '../../shared/api.js'
    import { quintOut  }  from 'svelte/easing'
	import { crossfade }  from 'svelte/transition'
    import { flip      }  from 'svelte/animate'

    export let domain
    export let activity
    export let projection
    export let place
    export let collapsed

    let error = null //{ place: 10, field: 4 }

    const ctx = getContext('activities')

    //console.log(`activity: ${projection.activity}, place: ${place.id}`)

    $: [ left, right ] = splitFields(projection, error) 

	const [send, receive] = crossfade({
		duration: d => Math.sqrt(d * 200),
		fallback(node, params) {
			const style = getComputedStyle(node)
			const transform = style.transform === 'none' ? '' : style.transform
			return {
				duration: 150,
				easing: quintOut,
				css: t => `
					transform: ${transform} scale(${t});
					opacity: ${t}
				`
			}
		}
	})


    function splitFields(projection, error) {
        const hasError = field => error && error.place === field.place && error.field === field.id
        const notDeleted = place.fields.filter(f => !f.deleted).map(field => {
            field.error = hasError(field)
            return field
        })

        //console.log(`Split => activity: ${activity.id}, place: ${place.id}, projection: ${projection && projection.id}`)
        if(!projection) {
            return [ notDeleted, [] ]
        } else {
            let left  = []
            let right = []
            const projected  = projection.fields.filter(f => f.place === place.id).filter(f => !f.deleted) || []
            notDeleted.forEach(field => {
                field.error = hasError(field)
                if(projected.find(p => p.field === field.id)) {
                    right.push(field)
                } else {
                    left.push(field)
                }
            })
            return [ left, right ]
        }
    }

    function toggleCollapse(place) {
        return e => {
            const found = collapsed.find(id => id === place.id)
            if(found) {
                collapsed = collapsed.filter(id => id !== place.id)
            } else {
                collapsed = [...collapsed, place.id]
            }
        }
    }

    function iconGiven(place, collapsed) {
        return isCollased(place, collapsed) ? "expand arrows" : "compress"
    }

    function isCollased(place, collapsed) {
        return collapsed.find(id => id === place.id)
    }

    function remove(place, field) {
        const data = { 
            id       : projection ? projection.id : 0,
            activity : activity.id, 
            field    : projection && projection.fields.find(it => it.place === place.id && it.field === field.id)
        }
        
        api
            .post(`/inventory/domain/${domain.id}/delete/projection`, data)
            .then(api.toJsonIf200)
            .then(json => {
                ctx.setInventory(json)
            })
            .catch(err => {
                console.log(err)
            })
    }

    function add(place, field) {
        
        const data = { 
            projection : projection ? projection.id : 0,
            activity   : activity.id, 
            field      : { 
                place: place.id, 
                field: field.id 
            } 
        }
        
        api
            .post(`/inventory/domain/${domain.id}/add/projection`, data)
            .then(api.toJsonIf200)
            .then(json => {
                ctx.setInventory(json)
            })
            .catch(err => {
                console.log(err)
                error = { place: place.id, field: field.id }
                setTimeout(() => {
                    error = null
                }, 3000)
            })
    }

    function toLeft(place, field) {
        return e => remove(place, field)
    }

    function toRight(place, field) {
        return e => add(place, field)
    }

    function isDisabled(field) {
        return activity.basis.name === 'LEGITIMATE_INTEREST' && field.sensitive
    }

    function scopes(field) {
        const translate = scope => {
            switch(scope) {
                case "SAR"  : return "sar"
                case "DDR"  : return "ddr"
                case "RET"  : return "ret"
                case "FIXED": return "fixo"
            }
        }
        return field.scopes.map(translate).join(",")
    }
    
</script>
<tr class="top aligned" transition:fade|local>
    <td>                        
        <button class="ui labeled icon button transparent" on:click={toggleCollapse(place)}>
            <i class="{ iconGiven(place, collapsed) } icon"></i>
            <!-- {JSON.stringify(place)} -->
            {place.name}
        </button>
    </td>
    {#if isCollased(place, collapsed)}
        <td class="center aligned collapsed">
            {#if left.length > 0}
                <div class="ui circular label">
                    { left.length }
                </div>
            {/if}
        </td>
        <td class="center aligned collapsed">
            {#if right.length > 0}
                <div class="ui black circular label">
                    { right.length }
                </div>
            {/if}
        </td>
        <td class="center aligned">
            <!-- <div class="ui circular label">0</div> -->
        </td>
    {:else}
        <td class="collapsing">
            <div class="column">
                {#if left.length === 0}
                    <div class="hero">Todos os campos estão em uso para esta atividade</div>
                {:else}
                    {#each left as field (field.id)}
                        <button data-content="Add users to your feed"
                                class="ui right labeled icon large scoped button" 
                                class:red={field.error}
                                class:disabled={isDisabled(field)}
                                on:click={toRight(place, field)}
                                in:receive="{{key: field.id}}"
                                out:send="{{key: field.id}}"
                                animate:flip>
                            <!-- {JSON.stringify(field)}                                 -->
                            {#if isDisabled(field)}
                                <i class="id badge icon"></i>
                            {:else}
                                <i class="arrow alternate circle right icon"></i>
                            {/if}
                            {field.name || field.definition}     
                            <span class="scope left">
                                {#if field.error} ERRO {:else} {scopes(field)} {/if}
                            </span>
                        </button>                    
                    {/each}                                
                {/if}
            </div>
        </td>
        <td class="collapsing">
            <div class="column">
                {#if right.length === 0}
                    <div class="hero">Nenhum dos campos está em uso para esta atividade</div>
                {:else}
                    {#each right as field (field.id)}
                        <button class="ui left labeled icon large green scoped button" on:click={toLeft(place, field)}
                                in:receive="{{key: field.id}}"
                                out:send="{{key: field.id}}"
                                animate:flip>
                            <i class="arrow alternate circle left icon"></i>
                            {field.name || field.definition} <span class="scope right">{scopes(field)}</span>
                        </button>                    
                    {/each}                                
                {/if}
            </div>
        </td>
    {/if}
</tr>
<style>
    .column {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        _border: 1px solid red;
    }

    .column button {
        margin: .5em;
        _background: transparent;
    }

    .column button i {
        _background: transparent;
    }
 
    button.transparent,
    button.transparent i.icon {
        background: transparent !important;
    }

    .hero {
        display: grid;
        place-items: center;
        _background: #fafafa;
        color: #ddd;
        width: 200px;
        height: 100%;
        margin: 1em;
        padding: 2em;
        border-radius: 6px;
        white-space: unset;
        white-space: normal;
        text-align: center;
    }

    button.scoped {
        position: relative;
    }

    .scope {
        position: absolute;
        font-size: 70%;
        opacity: 0.7;
        bottom: 2px;
    }

    .scope.right {
        right: 4px;
    }
    .scope.left {
        left: 4px;
    }

</style>